import { createContext, useContext, Dispatch, SetStateAction } from 'react'

import { GetConversationResponse, GetProfileResponse } from '../types'
import { EMPTY_CONVERSATION, EMPTY_PROFILE } from '../constants'

export interface ChatState {
  showChat: boolean,
  isChatActive: boolean,
  isChatVisible: boolean,
  viewers: number,
  setShowChat: (value: boolean) => void,
  setIsChatActive: (value: boolean) => void,
  setViewers: (value: number) => void,
  adminIds: string[],
  setAdminIds: Dispatch<SetStateAction<string[]>>,
  profile: GetProfileResponse,
  setProfile: Dispatch<SetStateAction<GetProfileResponse>>,
  conversation: GetConversationResponse,
  setConversation: Dispatch<SetStateAction<GetConversationResponse>>,
  isLoaded: boolean,
  setIsLoaded: Dispatch<SetStateAction<boolean>>,
  hasError: boolean,
  setHasError: Dispatch<SetStateAction<boolean>>,
  isLoading: boolean,
  setIsLoading: Dispatch<SetStateAction<boolean>>,
  isMuted: boolean,
  setIsMuted: Dispatch<SetStateAction<boolean>>
}

export const INITIAL_STATE: ChatState = {
  showChat: true,
  isChatActive: false,
  isChatVisible: false,
  viewers: 0,
  setShowChat: () => void 0,
  setIsChatActive: () => void 0,
  setViewers: () => void 0,
  adminIds: [],
  setAdminIds: () => void 0,
  profile: EMPTY_PROFILE,
  setProfile: () => void 0,
  conversation: EMPTY_CONVERSATION,
  setConversation: () => void 0,
  isLoaded: false,
  setIsLoaded: () => void 0,
  hasError: false,
  setHasError: () => void 0,
  isLoading: false,
  setIsLoading: () => void 0,
  isMuted: false,
  setIsMuted: () => void 0
}

export const ChatContext = createContext(INITIAL_STATE)

export const useChatContext = () => useContext(ChatContext)
